import taskGroups from './task-groups';
import taskGroupTags from './task-group-tags';
import taskGroupTasks from './task-group-tasks';

const tasksGroupActions = {
  ...taskGroups,
  ...taskGroupTags,
  ...taskGroupTasks,
};

export default tasksGroupActions;
